import React from 'react'

function VectorIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6668 11.9003H2.33301C1.90512 11.9003 1.55556 11.5661 1.55556 11.1569V2.2312C1.55556 1.82202 1.90512 1.48775 2.33301 1.48775H6.22253C6.64968 1.48775 6.99998 1.15276 6.99998 0.743583C6.99998 0.335111 6.64968 0.000126641 6.22253 0.000126641H1.55564C0.692466 0.000126641 0 0.669372 0 1.48775V11.9004C0 12.7187 0.699845 13.388 1.55564 13.388H12.4444C13.3001 13.388 14 12.7187 14 11.9004V7.43753C14 7.02906 13.6497 6.69408 13.2225 6.69408C12.7947 6.69408 12.4444 7.02906 12.4444 7.43753V11.157C12.4444 11.5662 12.0947 11.9003 11.6668 11.9003ZM8.5556 0.743601C8.5556 1.15278 8.90516 1.48776 9.33305 1.48776H11.3475L4.24635 8.27845C3.94334 8.56821 3.94334 9.03674 4.24635 9.3272C4.55009 9.61696 5.04005 9.61696 5.34305 9.3272L12.4442 2.53652V4.46291C12.4442 4.87209 12.7945 5.20637 13.2224 5.20637C13.6496 5.20637 13.9999 4.87209 13.9999 4.46291V0.743457C13.9999 0.334984 13.6496 0 13.2224 0H9.3329C8.90501 0 8.5556 0.335129 8.5556 0.743601Z"
        fill="#4A4A4A"
      />
    </svg>
  )
}

export default VectorIcon
